import { render, staticRenderFns } from "./EanScanner.vue?vue&type=template&id=8754cbf8&"
import script from "./EanScanner.vue?vue&type=script&lang=js&"
export * from "./EanScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports